export default function(
  num: undefined | null | number,
  fixPosition = 2
): string {
  if (!num) {
    return "0";
  }
  return num.toFixed(fixPosition);
}
